<template>
  <div class="leaderboard__wrapper mt-6 my-4x">
    <v-card flat class="grey lighten-4 mx-auto d-flex align-center" width="728" height="90">
      <v-card-text class="text-center text-overline accent--text">LEADERBOARD<br>728 x 90</v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'Leaderboard'
  }
</script>